import BaseComponent from 'foundation/base-component';

export default class FormFileComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.defaultCaption = this.element.dataset.placeholder || 'No file chosen';
        this.init();
    }

    static getRequiredRefs() {
        return ['native', 'caption'];
    }

    init() {
        this.fileInput = this.refs.native;
        this.captionContainer = this.refs.caption;

        this.caption = document.createElement('span');
        this.captionContainer.appendChild(this.caption);


        this.fileInput.addEventListener('change', this.onFileChange.bind(this));
        this.updateCaption();
    }

    onFileChange() {
        this.updateCaption();
    }

    updateCaption() {
        let caption = '';
        if (this.fileInput.files && this.fileInput.files.length > 1) {
            caption = `${this.fileInput.files.length} files selected`;
        } else {
            caption = this.fileInput.value.split('\\').pop();
        }
        if (caption) {
            this.caption.innerHTML = caption;
        } else {
            this.caption.innerHTML = this.defaultCaption;
        }
    }
}
